import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/ppi/audit-kepatuhan-ppi";

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

// Master
const getCatalog = () => handle(http.getData(`${BASE}/catalog`));

// Sessions
const getList = (params?: any) =>
  handle(http.getDataParam(`${BASE}/sessions`, params));
const find = (id: number) => handle(http.getData(`${BASE}/sessions/${id}`));
const create = (data: any) => handle(http.postData(`${BASE}/sessions`, data));
const update = (id: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${id}`, data));
const destroy = (id: number) =>
  handle(http.deleteData(`${BASE}/sessions/${id}`));

// Items (sync per-seksi + custom reuse)
const syncItems = (sessionId: number, items: any[]) =>
  handle(http.postData(`${BASE}/sessions/${sessionId}/items/sync`, { items }));

// Sign (4-tier)
const submitAuditor = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/submit-auditor`, data));
const verifyKetuaPpi = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/verify-ketua-ppi`, data));
const approveKaunit = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/approve-kaunit`, data));
const approveDirektur = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/approve-direktur`, data));

// Temuan
const storeTemuan = (sessionId: number, data: any) =>
  handle(http.postData(`${BASE}/sessions/${sessionId}/temuan`, data));
const updateTemuan = (sessionId: number, temuanId: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${sessionId}/temuan/${temuanId}`, data));
const destroyTemuan = (sessionId: number, temuanId: number) =>
  handle(http.deleteData(`${BASE}/sessions/${sessionId}/temuan/${temuanId}`));
const getTemuanTerbuka = (params?: any) =>
  handle(http.getDataParam(`${BASE}/temuan-terbuka`, params));

// Dashboard
const getDashboard = (params?: any) =>
  handle(http.getDataParam(`${BASE}/dashboard`, params));

// PDF
const printPdf = (id: number) => {
  window.open(`${http.getAPI()}${BASE}/sessions/${id}/pdf`, "_blank");
};

export default {
  getCatalog,
  getList,
  find,
  create,
  update,
  destroy,
  syncItems,
  submitAuditor,
  verifyKetuaPpi,
  approveKaunit,
  approveDirektur,
  storeTemuan,
  updateTemuan,
  destroyTemuan,
  getTemuanTerbuka,
  getDashboard,
  printPdf
};
